import { render, staticRenderFns } from "./UniversalGridWrapper.vue?vue&type=template&id=00d40270&"
import script from "./UniversalGridWrapper.ts?vue&type=script&lang=ts&"
export * from "./UniversalGridWrapper.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports